var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 92,
    viewBox: "0 0 104 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.328 84.5147L56.2924 2.49476C54.3846 -0.831179 49.6156 -0.831179 47.7078 2.49476L0.671743 84.5147C-1.23606 87.8406 1.14841 91.9989 4.96402 91.9989H99.0361C102.852 91.9989 105.236 87.8406 103.328 84.5147V84.5147ZM57.9162 84.4951H46.0839V73.2545H57.9162V84.4951ZM57.9162 68.1662H46.0839V22.4722H57.9162V68.1662Z",
    fill: "#82BCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemError);
export default __webpack_public_path__ + "static/media/systemError.23c20df02f66cd9bad7b880c550f1c1a.svg";
export { ForwardRef as ReactComponent };